'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import Header from './components/header';
import Showcase from './components/showcase';
import { gsap, ScrollTrigger } from '@/lib/gsap';
const Works = () => {
  const $ = _c(3);
  const containerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      gsap.set(containerRef.current, {
        backgroundColor: "#ebf400",
        color: "#000000"
      });
      ScrollTrigger.create({
        trigger: containerRef.current,
        start: "top top",
        end: "+=100%",
        onLeave: () => {
          gsap.to(containerRef.current, {
            backgroundColor: "#37353E",
            color: "#ffffff",
            duration: 1.2,
            ease: "power3.out"
          });
        },
        onEnterBack: () => {
          gsap.to(containerRef.current, {
            backgroundColor: "#ebf400",
            color: "#000000",
            duration: 1.2,
            ease: "power3.out"
          });
        }
      });
    };
    t1 = {
      scope: containerRef
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useGSAP(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section ref={containerRef} className="bg-accent" id="works"><Header /><Showcase /></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Works;